 <div class="d-flex  justify-content-center search-box" style="z-index: 1;" id="search-box"
  [ngStyle]="{'background-image': 'url(&quot;' + routeUploadFile+sectionSearchBox?.background_image + '&quot;)'}">

  <div class="mt-4 col-xg-10 col-lg-10 col-md-10 col-xs-12 " id="menu-principal"
  [ngStyle]="{'background-color': sectionSearchBox.background_box}">
      <div class="tabss flex-row col-xg-12 col-lg-12 col-md-12 col-xs-12  justify-content-center">
        <!-- <usb-dynamic-forms-container-category-search></usb-dynamic-forms-container-category-search> -->
          <tabset id="search" style="width: 100%; ">
            <!--**********************************
              *-->
              <!--***********Search Hotels***********-->
              <!--***********************************-->
              <tab (select)="selectTab('HOTELS') " [active]="tab==='HOTELS' ">
                <ng-template tabHeading >
                  <a class="hotel">
                    <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                      <!-- <svg-icon src="../../../assets/img/app/categories-search-box/ima_hotel.svg" [ngClass]="{'active': activeBtn === 'HOTELS'}"
                        [ngStyle]="{'fill': activeBtn === 'HOTELS' ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}"
                        style="margin-left: 8px;"></svg-icon> -->
                        <img src="../../../assets/img/app/categories-search-box/ima_hotel.svg"
                          [ngClass]="{'active': activeBtn === 'HOTELS'}"
                          [style.filter]="getAlertFilter('HOTELS')"
                          style="width: 28px;"
                         >
                    </span>
                      <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">ALOJAMIENTO</h5></span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='HOTELS' " >
                    <usb-hotels *ngIf="reloadCategories" [_close]="_close " [getClientsSettingAppBooking]="getClientsSettingAppBooking" (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                    </usb-hotels>
                  </ng-template>
                </tab>
                 <!--***********Search flights***********-->
              <!--***********************************-->
              <tab (select)="selectTab('FLIGHTS') " [active]="tab==='FLIGHTS' " [disabled]="true">
                <ng-template tabHeading >
                  <a class="flights">
                    <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                        <img src="../../../assets/img/app/categories-search-box/AEREO.svg"
                          [ngClass]="{'active': activeBtn === 'FLIGHTS'}"
                          [style.filter]="getAlertFilter('FLIGHTS')"
                          style="width: 28px;"
                         >
                    </span>
                      <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">VUELOS</h5></span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='FLIGHTS' " >
                    <usb-flights [_close]="_close " [getClientsSettingAppBooking]="getClientsSettingAppBooking" (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                    </usb-flights>
                  </ng-template>
                </tab>
                <!--*********Search Activities*********-->
              <!--***********************************-->
              <tab (select)="selectTab('EXPERIENCIAS')" [active]="tab==='EXPERIENCIAS'">
                <ng-template tabHeading >
                    <a class="tour">
                      <span class="circle-icon img-fluid mx-auto d-block"  [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                        <!-- <svg-icon src="../../../assets/img/app/categories-search-box/road-map.svg" [ngClass]="{'active': activeBtn === 'EXPERIENCIAS'}"
                        [ngStyle]="{'fill': activeBtn === 'EXPERIENCIAS' ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}"
                        ></svg-icon> -->
                         <img src="../../../assets/img/app/categories-search-box/road-map.svg"
                          [ngClass]="{'active': activeBtn === 'EXPERIENCIAS'}"
                          [style.filter]="getAlertFilter('EXPERIENCIAS')"
                          style="width: 28px;"
                         >
                      </span>
                        <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">EXPERIENCIAS</h5></span>
                    </a>
                </ng-template>
                <ng-template [ngIf]="tab==='EXPERIENCIAS' ">
                    <usb-activities *ngIf="reloadCategories" [categoryId]="category.experience" [_close]="_close " [getClientsSettingAppBooking]="getClientsSettingAppBooking" [tabName]="tab" (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                    </usb-activities>
                </ng-template>
            </tab>
             <!--***********************************-->
                <!--********Search for transfers*******-->
                <!--***********************************-->
                <tab (select)="selectTab('TRANSPORTE')" [active]="tab==='TRANSPORTE'" class="flex-fill">
                  <ng-template tabHeading>
                      <a class="bus" >
                        <span class=" circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                          <!-- <svg-icon src="../../../assets/img/app/categories-search-box/bus.svg" [ngClass]="{'active': activeBtn === 'TRANSPORTE'}"
                          [ngStyle]="{'fill': activeBtn === 'TRANSPORTE' ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}"
                          ></svg-icon> -->
                        <img src="../../../assets/img/app/categories-search-box/bus.svg"
                          [ngClass]="{'active': activeBtn === 'TRANSPORTE'}"
                          [style.filter]="getAlertFilter('TRANSPORTE')"
                          style="width: 28px;"
                         >
                        </span>
                          <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">TRASLADO</h5></span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='TRANSPORTE' ">
                      <usb-transports *ngIf="reloadCategories" [_close]="_close " [getClientsSettingAppBooking]="getClientsSettingAppBooking" (modal)="openModal($event) " (origin)="_onOrigin($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event)" [getClientsSettingAppBooking]="getClientsSettingAppBooking">
                      </usb-transports>
                  </ng-template>
              </tab>
                <!--***********************************-->
                <!--******Multi-destination search*****-->
                <!--***********************************-->
                <tab id="fly" tab (select)="selectTab('MULTIDESTINO')" [active]="tab === 'MULTIDESTINO'" [disabled]="true">
                    <ng-template tabHeading >
                        <a class="destinations">
                          <span class="circle-icon img-fluid mx-auto d-block"
                              [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"  >
                            <svg-icon src="../../../assets/img/app/categories-search-box/worldwide.svg"
                            [ngClass]="{'active': activeBtn === 'MULTIDESTINO'}"
                            [ngStyle]="{'fill': activeBtn === 'MULTIDESTINO' ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}"
                            style="margin-top: -4px; margin-left: 3px;"></svg-icon></span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">MULTIDESTINO</h5></span>
                        </a>
                    </ng-template>
                    <ng-template [ngIf]="tab==='MULTIDESTINO' ">
                        <usb-multi-destination [_close]="_close " (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                        </usb-multi-destination>
                    </ng-template>
                </tab>

              <!--***********************************-->
              <!--***********************************-->
              <!--***********************************-->
              <!--********Search for P THEMES*******-->
              <!--***********************************-->
               <tab (select)="selectTab( 'TICKETS') " [active]="tab==='TICKETS' " class="flex-fill">
                  <ng-template tabHeading>
                      <a class="pthemes">
                        <span class=" circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                          <img src="../../../assets/img/app/categories-search-box/combi-ticket.svg"
                          [ngClass]="{'active': activeBtn === 'TICKETS'}"
                          [style.filter]="getAlertFilter('TICKETS')"
                          style="width: 30px;"
                         ></span>
                         <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">TICKETS</h5></span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='TICKETS' ">
                    <usb-activities *ngIf="reloadCategories" [_close]="_close " [categoryId]="category.tickets" [getClientsSettingAppBooking]="getClientsSettingAppBooking" [tabName]="tab" (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                    </usb-activities>
                  </ng-template>
              </tab>

              <!-- Search Guía -->
               <!-- <tab (select)="selectTab( 'GUIDE') " [active]="tab==='GUIDE' " class="flex-fill">
                (select)="selectTab( 'PTHEMES') "
                  <ng-template tabHeading>
                      <a class="pthemes">
                        <span class=" circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                          <svg-icon src="../../../assets/img/app/categories-search-box/combi-ticket.svg" [ngClass]="{'active': activeBtn === 'guide'}"
                          [ngStyle]="{'fill': activeBtn === 'guide' ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}"
                          (click)="changeActiveBtn('guide')"
                         ></svg-icon></span>
                         <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">GUÍA</h5></span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='GUIDE' ">
                      <usb-pthemes [_close]="_close "  (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                      </usb-pthemes>
                    <usb-activities [_close]="_close " [categoryId]="category.guide" [getClientsSettingAppBooking]="getClientsSettingAppBooking" [tabName]="tab" (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                    </usb-activities>
                  </ng-template>
              </tab> -->

              <!-- Search ski -->
               <!-- <tab (select)="selectTab( 'SKI') " [active]="tab==='SKI' " class="flex-fill">
                (select)="selectTab( 'PTHEMES') "
                  <ng-template tabHeading>
                      <a class="pthemes">
                        <span class=" circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                          <svg-icon src="../../../assets/img/app/categories-search-box/combi-ticket.svg" [ngClass]="{'active': activeBtn === 'ski'}"
                          [ngStyle]="{'fill': activeBtn === 'ski' ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}"
                          (click)="changeActiveBtn('ski')"
                         ></svg-icon></span>
                         <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">SKI</h5></span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='SKI' ">
                      <usb-pthemes [_close]="_close "  (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                      </usb-pthemes>
                    <usb-activities [_close]="_close " [categoryId]="category.ski" [getClientsSettingAppBooking]="getClientsSettingAppBooking" [tabName]="tab" (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                    </usb-activities>
                  </ng-template>
              </tab> -->
              <!--*************Search Car************-->
              <!--***********************************-->
              <tab (select)="selectTab( 'CAR') " [active]="tab==='CAR' ">
                  <ng-template tabHeading >
                      <a class="cars">
                        <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                          <!-- <svg-icon src="../../../assets/img/app/categories-search-box/car-compact.svg" [ngClass]="{'active': activeBtn === 'CAR'}"
                          [ngStyle]="{'fill': activeBtn === 'CAR' ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}"
                          ></svg-icon> -->
                          <img src="../../../assets/img/app/categories-search-box/car-compact.svg"
                          [ngClass]="{'active': activeBtn === 'CAR'}"
                          [style.filter]="getAlertFilter('CAR')"
                          style="width: 30px;"
                         >
                        </span>
                          <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">RENT A CAR</h5></span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='CAR' ">
                      <usb-rentcars *ngIf="reloadCategories" (payload)="_onPayload($event) " [getClientsSettingAppBooking]="getClientsSettingAppBooking" (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) "></usb-rentcars>
                  </ng-template>
              </tab>

              <!--***********************************-->
              <!--********Search for packages********-->
              <!--***********************************-->
              <tab (select)="selectTab( 'PACKAGES') " [active]="tab==='PACKAGES' " class="flex-fill" [disabled]="true">
                  <ng-template tabHeading >
                      <a class="packs">
                        <span class=" circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">

                         <img src="../../../assets/img/app/categories-search-box/maleta.svg"
                          [ngClass]="{'active': activeBtn === 'PACKAGES'}"
                          [style.filter]="getAlertFilter('PACKAGES')"
                          style="width: 26px;"
                         >
                        </span>
                          <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">PAQUETES</h5></span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='PACKAGES' ">
                      <usb-packages *ngIf="reloadCategories" [_close]="_close " (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (origin)="_onOrigin($event) " (isLoading)="_onLoading($event) ">
                      </usb-packages>
                  </ng-template>
              </tab>
              <!-- ***********************************
              <!--********Search for Disney********-->
              <!--***********************************-->
              <!-- <tab (select)="selectTab( 'DISNEY') " [active]="tab==='DISNEY' ">
                  <ng-template tabHeading>
                      <a class="disney">
                          <i class="icon-disneys " aria-hidden="true "></i>
                          <span>
                            DISNEY
                          </span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='DISNEY' ">
                      <usb-disney [_close]="_close " (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (origin)="_onOrigin($event) " (isLoading)="_onLoading($event) ">
                      </usb-disney>
                  </ng-template>
              </tab> -->

              <!--***********************************-->
              <!--********Search for INSURANCE*******-->
              <!--***********************************-->
              <tab (select)="selectTab( 'INSURANCE') " [active]="tab==='INSURANCE' " class="flex-fill" >
                  <ng-template tabHeading >
                      <a class="seguro">
                        <span class=" circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                          <!-- <img src="../../../assets/img/app/categories-search-box/icon-seguro.svg"  [ngClass]="{'active': activeBtn === 'INSURANCE'}"
                          [ngStyle]="{'fill': activeBtn === 'INSURANCE' ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}"

                        > -->
                          <img src="../../../assets/img/app/categories-search-box/icon-seguro.svg"
                          [ngClass]="{'active': activeBtn === 'INSURANCE'}"
                          [style.filter]="getAlertFilter('INSURANCE')"
                          style="width: 30px;"
                         >
                      </span>
                          <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">ASISTENCIA</h5></span>
                      </a>
                  </ng-template>
                  <ng-template [ngIf]="tab==='INSURANCE' ">
                      <usb-insurance *ngIf="reloadCategories" [_close]="_close " (modal)="openModal($event) " (payload)="_onPayload($event) " (results)="_onResults($event) " (isLoading)="_onLoading($event) " (origin)="_onOrigin($event) ">
                      </usb-insurance>
                  </ng-template>
              </tab>
          </tabset>
      </div>
  </div>
<br>
  <div class="separator-section"></div>
</div>
<div class="corte "></div>
